module.exports = __webpack_public_path__ + "images/emoji/dress.886e7182e842e2bc2fad.png";